import _ from 'lodash';
import React, { Component } from 'react';

import Select from 'react-select';

import {
  getIcon,
  getCountryIcon,
  getOptionValueForSelect,
} from '../../util';

import {
  getLanguageOptions
} from '../../util/data';

class LanguageSelect extends Component {

  state = {

  }

  render(){

    const { currentLanguage } = this.props;

    return (
      <div
        className={`language-select-container`}
      >
        <Select
          classNamePrefix={'react-select'}
          className={`react-select-container language-select`}
          value={getOptionValueForSelect(getLanguageOptions(), currentLanguage)}
          options={getLanguageOptions()}
          onChange={(option) => { this.props.changeLanguage(option.value); }}
          isSearchable={true}
        />
      </div>
    )
  }
}
export default LanguageSelect;



// WEBPACK FOOTER //
// ./src/components/shared/languageSelect.js